import React, { useContext, useEffect } from "react";
import ChatSessionContext from "../../../contexts/ChatSessionContext";
import AppContext from "../../../AppContext";
import { ReactComponent as SupportSvg } from "../../../assets/icons/support.svg";
import { ReactComponent as ChatSvg } from "../../../assets/icons/chat.svg";

const ChatBubbles = () => {
  const { user, toggleChatWindow } = useContext(AppContext);
  const { toggleChatSupportWindow, isNewMessage, setIsSupport } =
    useContext(ChatSessionContext);

  const _handleToggleChat = () => {
    setIsSupport(false);
    toggleChatWindow();
  };

  useEffect(() => {}, []);

  return (
    <div className="chat-minimized">
      <div
        className="chat-bubble"
        onClick={toggleChatSupportWindow}
        role="button"
      >
        <SupportSvg className="chat-bubble__icon" width={26} />
      </div>
      <div className="chat-bubble" onClick={_handleToggleChat} role="button">
        <ChatSvg className="chat-bubble__icon" width={26} />
        {isNewMessage && <div className="chat-bubble__new-alert" />}
      </div>
    </div>
  );
};

ChatBubbles.propTypes = {};

export default ChatBubbles;
